import { render } from "./ResourceView.vue?vue&type=template&id=08af3861"
import script from "./ResourceView.vue?vue&type=script&lang=js"
export * from "./ResourceView.vue?vue&type=script&lang=js"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__